























































































































import { Component, Vue } from 'vue-property-decorator';
import {
  FilterDTO, CatalogItemFullDTOTypeEnum,
  SupplierDTO, CatalogItemShortDTO,
} from '@/api';
import EditingLayout from '@/layouts/EditingLayout.vue';
import Upload from '@/components/common/Upload.vue';
import { clientsModule } from '@/store';
import services from '@/services';
import { Form } from 'element-ui';
import {
  filterObject, fileReader, getAuthToken, throwError, getAssetUrl,
} from '@/utils';
import axios from 'axios';
import CatalogItemPrice from '@/components/CatalogItemPrice.vue';
// import { fileToBase64 } from 'ts-image-processor';
import ThingForm from './ThingForm.vue';

interface IForm {
  name: string;
  type: CatalogItemFullDTOTypeEnum | undefined;
  brandId: string | undefined;
  categoryId: number | undefined;
  gender: string | undefined;
  colorId: string | undefined;
  supplierId: string | undefined;
  size: string | undefined;
  price: number | undefined;
  priceDiscount: number | undefined;
  thingUrl: string | undefined;
  temperatureFrom: string | undefined;
  temperatureTo: string | undefined;
}

interface IThingItem {
  imgUrl: string | null;
  file?: File | undefined;
  catalogItem?: CatalogItemShortDTO;
  catalogItemPriceId?: number,
  form: IForm;
}

@Component({
  name: 'add-thing-page',
  components: {
    EditingLayout,
    ThingForm,
    Upload,
    CatalogItemPrice,
  },
})
export default class AddThings extends Vue {
  loading = false;

  things: IThingItem[] = [];

  groupEditing = false;

  categories: FilterDTO[] = [];

  brands: FilterDTO[] = [];

  colors: FilterDTO[] = [];

  genders: FilterDTO[] = [];

  suppliers: SupplierDTO[] = [];

  items: CatalogItemShortDTO[] = [];

  selectedItems: number[] = [];

  imgLoading = false;

  get thingTypes() {
    return Object.values(CatalogItemFullDTOTypeEnum);
  }

  get client() {
    return clientsModule.model;
  }

  common: IForm = {
    name: '',
    type: CatalogItemFullDTOTypeEnum.CLOTHES,
    brandId: undefined,
    categoryId: undefined,
    gender: undefined,
    colorId: '90',
    supplierId: undefined,
    size: '',
    price: undefined,
    priceDiscount: undefined,
    thingUrl: undefined,
    temperatureFrom: undefined,
    temperatureTo: undefined,
  }

  async created() {
    if (this.client && this.client.id != null) {
      const { data: categories } = await services.catalogService()
        .catalogEndpointGetClientCategoryNames(this.client.id);
      this.categories = categories;
    }
    const { data: brands } = await services.catalogService().catalogEndpointGetFilterNames('BRAND');
    const { data: colors } = await services.catalogService().catalogEndpointGetFilterNames('COLOR');
    const { data: genders } = await services.catalogService().catalogEndpointGetFilterNames('GENDER');
    const { data: suppliers } = await services.catalogService().catalogEndpointGetSuppliersList();

    this.brands = brands;
    this.colors = colors;
    this.genders = genders;
    this.suppliers = suppliers;
  }

  async onFiles(files: File[]) {
    this.imgLoading = true;
    try {
      const urls = await this.uploadImage(files);
      const things: IThingItem[] = await Promise.all(urls.map(async url => ({
      // imgUrl: await fileToBase64(file),
      // file,
        imgUrl: url,
        catalogItemId: undefined,
        catalogItemPriceId: undefined,
        form: {
          name: '',
          type: undefined,
          brandId: undefined,
          categoryId: undefined,
          gender: undefined,
          colorId: '90',
          supplierId: undefined,
          size: '',
          price: undefined,
          priceDiscount: undefined,
          thingUrl: '',
          temperatureFrom: undefined,
          temperatureTo: undefined,
        },
      })));
      this.things.push(...things);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      this.imgLoading = false;
    }
  }

  addThing() {
    this.things.push({
      imgUrl: null,
      catalogItem: undefined,
      catalogItemPriceId: undefined,
      file: undefined,
      form: {
        name: '',
        type: undefined,
        brandId: undefined,
        categoryId: undefined,
        gender: undefined,
        colorId: '90',
        supplierId: undefined,
        size: '',
        price: undefined,
        priceDiscount: undefined,
        temperatureFrom: undefined,
        temperatureTo: undefined,
        thingUrl: '',
      },
    });
  }

  updateForm<K extends keyof IForm>(index: number, propertyName: K, value: IForm[K]) {
    this.things[index].form[propertyName] = value;
  }

  onDelete(index: number) {
    this.things.splice(index, 1);
  }

  onCopy(index: number, item: IThingItem) {
    this.things.splice(index, 0, { ...item, form: { ...item.form } });
  }

  onImprove(index: number, url: string | null) {
    this.things[index].imgUrl = url;
  }

  async onFile(index: number, file: File) {
    // this.things[index].imgUrl = await fileToBase64(file);
    // this.things[index].file = file;
    this.imgLoading = true;
    try {
      const [url] = await this.uploadImage([file]);
      this.things[index].imgUrl = url;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    } finally {
      this.imgLoading = false;
    }
  }

  setCommon() {
    const common = filterObject(this.common);
    this.things.forEach((_, index) => {
      this.$set(this.things[index], 'form', Object.assign(this.things[index].form, common));
    });
  }

  addSupplier(item: SupplierDTO) {
    this.suppliers.push(item);
  }

  addBrand(item: FilterDTO) {
    this.brands.push(item);
  }

  async uploadImage(files: File[]) {
    const urls = await Promise.all(files.map(async file => fileReader(file)
      .then(binary => axios.post<string>(`https://rest.styleconcierge.ru/api/story/uploadBackground/${file.name}`, binary, {
        headers: { 'Content-Type': 'application/octet-stream', Authorization: `Bearer ${getAuthToken()}` },
      })
        .catch((e) => {
          throwError('Ошибка загрузки изображений');
          this.loading = false;
          throw new Error(e);
        }))));
    return urls.map(u => u.data);
  }

  async onSubmit() {
    this.loading = true;
    const forms: Form[] = Array.isArray(this.$refs.forms)
      ? (this.$refs.forms as any).map((form: any) => form.$refs.form)
      : [];
    const validatorsResult = await Promise.all(forms.map(async (form) => {
      try {
        const result = await form.validate();
        return result;
      } catch (e) {
        return false;
      }
    }));

    if (validatorsResult.every(f => f)) {
      try {
        const t = this.things.map(async ({
          form, catalogItem, catalogItemPriceId, imgUrl,
        }, index) => {
          try {
            if (catalogItem?.id && catalogItemPriceId) {
              if (this.client?.id != null) {
                await services.sandboxApi()
                  .sandboxEndpointAddItem(this.client.id, catalogItem.id, catalogItemPriceId);
              }
            } else {
              const { data: thingId } = await services.catalogService()
                .catalogEndpointSaveItem(
                  form.name,
                  form.type as string,
                  form.brandId as string,
                  Number(form.categoryId),
                  Number(form.colorId),
                  form.gender as string,
                  form.supplierId as string,
                  form.size as string,
                  form.price as number,
                  undefined,
                  undefined,
                  undefined,
                  form.priceDiscount,
                  '',
                  undefined,
                  form.thingUrl,
                  this.client?.id,
                  form.temperatureFrom,
                  form.temperatureTo,
                );
              if (imgUrl) {
                await services.catalogService()
                  .catalogEndpointSetItemPictureFromUrl(thingId, imgUrl);
              }
            }
            return index;
          } catch (e) {
            throw e;
          }
        });
        const results = await Promise.allSettled(t);
        // @ts-ignore
        const fulfilledIndexes: number[] = results.filter(result => result.status === 'fulfilled').map(result => result.value);
        // @ts-ignore
        const rejected = results.filter(result => result.status === 'rejected').map(result => result.reason.message);
        this.things = this.things.filter((_, index) => !fulfilledIndexes.includes(index));
        if (rejected.length > 0) {
          throw rejected;
        }
        this.$message({
          type: 'success',
          message: `Вещь: ${fulfilledIndexes.map(i => i + 1).join(', ')} успешно сохранена`,
        });
        this.back();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        this.$notify({ title: 'Ошибка!', message: error, type: 'error' });
      } finally {
        this.loading = false;
      }
    }
    this.loading = false;
    return null;
  }

  onCatalogItem(index: number, item: CatalogItemShortDTO) {
    if (item) {
      // const brand = this.brands.find(b => b.name === item.brandName);
      this.things[index].catalogItem = item;
      this.things[index].catalogItemPriceId = item.prices?.length && item.prices[0].id;
      this.things[index].imgUrl = this.getImgUrl(item.pictUrl);
    // this.things[index].form.name = item.name;
    // this.things[index].form.brandId = brand?.id;
    // this.things[index].form.priceDiscount = item.priceDiscount;
    // this.things[index].form.size = (item.prices || [])[0].size || '';
    // this.things[index].form.price = (item.prices || [])[0].price || 0;
    // this.things[index].form.priceDiscount = item.priceDiscount;
    } else {
      this.things[index].catalogItem = undefined;
      this.things[index].imgUrl = null;
    }
  }

  onPrice(index: number, priceId: number) {
    this.things[index].catalogItemPriceId = priceId;
  }

  back() {
    if (this.$route.name === 'catalog-add-to-sandbox') {
      this.$router.push({ name: 'client-sandbox' });
    } else {
      this.$router.push('clients');
    }
  }

  selectItem(itemId: number) {
    const index = this.selectedItems.indexOf(itemId);
    if (index > -1) {
      this.selectedItems.splice(index, 1);
    } else {
      this.selectedItems.push(itemId);
    }
  }

  getImgUrl(path: string) {
    return getAssetUrl(path);
  }
}
